import React from "react";
import { Megaphone, X } from "lucide-react";

const COPY = {
  free: { title: "Advertisements are now FREE", body: "You can post ads at no cost right now. Ads are shown only in the PIN Code Areas you select.", tone: "border-emerald-200 bg-emerald-50 text-emerald-900", icon: "text-emerald-700" },
  paid: { title: "Advertisements are now PAID", body: "Payment is required before a new advertisement becomes active. Ads are shown only in the PIN Code Areas you select.", tone: "border-amber-200 bg-amber-50 text-amber-900", icon: "text-amber-700" },
};

export const AdModeNotice = ({ notice, onDismiss, place }) => {
  const c = notice && COPY[notice.mode];
  if (!c) return null;
  return (
    <div role="status" className={`flex items-start gap-3 rounded-2xl border px-4 py-3 mb-4 ${c.tone}`} data-testid={`ad-mode-notice-${place}`} data-mode={notice.mode}>
      <Megaphone className={`w-5 h-5 mt-0.5 flex-shrink-0 ${c.icon}`} />
      <div className="min-w-0 flex-1">
        <p className="text-sm font-semibold" data-testid={`ad-mode-notice-title-${place}`}>{c.title}</p>
        <p className="text-xs sm:text-sm mt-0.5 opacity-90" data-testid={`ad-mode-notice-body-${place}`}>{c.body}</p>
      </div>
      <button type="button" onClick={onDismiss} aria-label="Dismiss notice" className="p-1.5 -m-1 rounded-full hover:bg-black/5 transition-colors flex-shrink-0" data-testid={`ad-mode-notice-dismiss-${place}`}>
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
